import * as firestore from 'firebase/firestore';
import { DateTime } from 'luxon';
import { ReceiptRequest } from '../types/ReceiptRequest';

export default {
  toFirestore(receiptRequest: ReceiptRequest): firestore.DocumentData {
    return receiptRequest;
  },
  fromFirestore(
    snapshot: firestore.QueryDocumentSnapshot
  ): ReceiptRequest {
    const data = snapshot.data()!;
    return {
      id: data.id,
      uid: data.uid,
      idNumber: data.idNumber,
      name: data.name,
      file: data.file,
      reason: data.reason,
      dateRequested: data.dateRequested,
      dateResponded: data.dateResponded,
      type: data.type,
      status: data.status,
      lastUpdate: DateTime.fromJSDate((data.lastUpdate as firestore.Timestamp).toDate()).toISO()
    };
  }
};
